import React, { PropTypes } from 'react';
import ExifReader from 'exifreader';
import ImportarFotosBase from './ImportarFotosBase';
import { round as mathRound, format as latlngFormat, abs, subtract, smallerEq } from 'mathjs';
import { prettyAlert } from '../Common/Dialog';

const COMPARE_TOLERANCE = Number(0.0002);

function approximatelyEqual(v1, v2, tolerance = COMPARE_TOLERANCE) {
	return smallerEq( abs( subtract(v1, v2) ), tolerance);
}

export default class FotosGeoreferenciadas extends ImportarFotosBase {

	async onDrop(files) {

		this.setState({isProcessing: true});
		let pointsToAdd = [];
		var repeatedPicturesInDatabase = [];

		for ( let file of files ) {

			let b = await fetch(file.preview).then(r => r.blob());
			if (b.size > 400 * 1024 * 1024) {
				prettyAlert(`${file.name} grande demais!`, `O limite máximo é de 400 MB por arquivo.`);
				continue;
			};

			this.setState({processingFilename: file.name});

			// Gets the hash of file and checks if it is already in database
			var isFileInDatabase = false;
			var filehash = '';
			await this.readFileAsync(file).then(
				(result) => { isFileInDatabase = result.tem_em_documento_no_bd; filehash = result.filehash; }, 
				(error) => { console.error("It failed with " + error); }
			);
			
			if (isFileInDatabase) {
				repeatedPicturesInDatabase.push(file.name);
				continue;
			}

			const tags = ExifReader.load(await file.arrayBuffer(), {expanded: true, includeUnknown: true});
			console.warn(`Tags found in "${file.name}": `); console.warn(tags);
			const tzlookup = require("tz-lookup");

			const _lat = tags.gps ? tags.gps.Latitude : "";
			const _lng = tags.gps ? tags.gps.Longitude : "";

			let lat = _lat;
			let lng = _lng;
			if (_lat && _lng) {
				lat = mathRound(_lat, 4);
				lng = mathRound(_lng, 4);
			}
			lat = latlngFormat(lat, {notation: 'fixed', precision: 4});
			lng = latlngFormat(lng, {notation: 'fixed', precision: 4});

			if (lat === '""') lat = '';
			if (lng === '""') lng = '';

			let exif, imageCaption, datetime;
			if (tags.exif) {
				exif = tags.exif;
				imageCaption = exif.ImageDescription ? exif.ImageDescription.description : "";
				datetime = exif.DateTime ? exif.DateTime.description : "";
			}
			const timezone = tzlookup(Number(_lat), Number(_lng));
			
			let foundInSavedPoints = false;
			if (lat && lng) {
				this.props.points.map((savedPoint, index) => {
					if (savedPoint.lat && savedPoint.lng) {
						var savedLat = latlngFormat(Number(savedPoint.lat), {notation: 'fixed', precision: 4});
						var savedLng = latlngFormat(Number(savedPoint.lng), {notation: 'fixed', precision: 4});
						
						if (approximatelyEqual(lat, savedLat) && approximatelyEqual(lng, savedLng)) {
							console.warn(
								`Found existing point matching ${savedLat} and ${savedLng} coordinates with index ${index}.`
							);
							this.props.addPointImageWithSrc(index, file, datetime, filehash);
							foundInSavedPoints = true;
						}
					}
				});
			}

			if (foundInSavedPoints) continue;
			
			let foundInNewPoints = false;
			if (lat && lng) {
				for (const pt of pointsToAdd) {
					if (approximatelyEqual(lat, pt.lat) && approximatelyEqual(lng, pt.lng)) {
						pt.img.push({
							caption: imageCaption,
							src: file,
							datetime: datetime,
							timezone: timezone,
							filehash: filehash
						});
						foundInNewPoints = true;
						break;
					}
				}
			}

			if (foundInNewPoints) continue;

			pointsToAdd.push({
				lat: lat,
				lng: lng,
				img: [
					{
						caption: imageCaption,
						src: file,
						datetime: datetime,
						timezone: timezone,
						filehash: filehash
					}
				]
			});

		}

		for (const pt of pointsToAdd) {
			this.props.createPointRaw(pt);
		}

		if (repeatedPicturesInDatabase.length > 0) {
			this.showAlert(repeatedPicturesInDatabase);
		}

		this.setState({isProcessing: false});
		this.setState({is_lightbox_open: false});
	}

	render () {
		return (
			<div>
				<button
					type="button"
					className="btn btn-primary btn-block"
					onClick={() => { this.setState({is_lightbox_open: true}); }}>
					Importar de fotos
				</button>
				{super.render()}
			</div>

		);
	}
}

FotosGeoreferenciadas.propTypes = {
	points: PropTypes.array.isRequired,
	createPoint: PropTypes.func.isRequired,
	createPointRaw: PropTypes.func.isRequired,
	addPointImageWithSrc: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/FotosGeoreferenciadas.js